var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEducationWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_182_6661)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 4L0 23.0001L4 25.3751V56H8V27.75L12.0041 30.1275V47.9931L12 48L31.9993 60L51.9983 48L51.9982 30.1261L64 23.0001L32 4ZM32 8.65195L7.83486 23.0001L32 37.3481L56.1651 23.0001L32 8.65195ZM16.0041 45.7377V32.5025L32 42L47.9983 32.5011L47.9983 45.7353L31.9993 55.3352L16.0041 45.7377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 22.9984L49.5686 14.4297L46.6498 17.3486L56.1652 22.9983L32 37.3463L28.6444 35.3539L25.7255 38.2728L32 41.9983L47.9983 32.4993L47.9983 45.7336L31.9993 55.3335L17.4155 46.5829L14.5 49.4983L31.9994 59.9983L51.9983 47.9983L51.9982 30.1244L64 22.9984Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_182_6661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationWhite);
export default __webpack_public_path__ + "static/media/education-white.f2127f642688137dfaac42063344cb9d.svg";
export { ForwardRef as ReactComponent };